import React, { useState } from 'react';
import { Droplets } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import ToolPageLayout from '../../components/ToolPageLayout';
import { useLanguage } from '../../contexts/LanguageContext';

const HydrationCalculator = () => {
  const { t } = useLanguage();
  const [weight, setWeight] = useState('');
  const [climate, setClimate] = useState('normal');
  const [activity, setActivity] = useState('0');

  const w = parseFloat(weight);
  const valid = w > 0;

  let ml = valid ? w * 35 : 0;
  if (climate === 'chaud') ml *= 1.15;
  if (climate === 'tres-chaud') ml *= 1.3;
  ml += parseInt(activity, 10) * 350;

  const liters = (ml / 1000).toFixed(1);

  return (
    <ToolPageLayout
      title={t('hydration_title')}
      subtitle={t('hydration_subtitle')}
      specialty="generaliste"
    >
      <div className="bg-[#E6F4FB] border border-[#0596DE]/20 rounded-2xl p-4 flex gap-3 mb-8">
        <Droplets className="w-5 h-5 text-[#0596DE] shrink-0 mt-0.5" />
        <p className="text-sm text-[#0F172A]">
          {t('hydration_info')}
        </p>
      </div>

      <div className="grid sm:grid-cols-3 gap-5 mb-8">
        <div>
          <Label className="mb-1 block">{t('hydration_weight_label')}</Label>
          <Input
            type="number"
            min="1"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
            placeholder="Ex: 70"
            className="rounded-xl"
          />
        </div>
        <div>
          <Label className="mb-1 block">{t('hydration_climate_label')}</Label>
          <select
            value={climate}
            onChange={(e) => setClimate(e.target.value)}
            className="w-full border border-[#E2E8F0] rounded-xl px-3 py-2 text-sm bg-white h-10 focus:outline-none focus:ring-2 focus:ring-[#0596DE]"
          >
            <option value="normal">{t('hydration_climate_normal')}</option>
            <option value="chaud">{t('hydration_climate_hot')}</option>
            <option value="tres-chaud">{t('hydration_climate_very_hot')}</option>
          </select>
        </div>
        <div>
          <Label className="mb-1 block">{t('hydration_activity_label')}</Label>
          <select
            value={activity}
            onChange={(e) => setActivity(e.target.value)}
            className="w-full border border-[#E2E8F0] rounded-xl px-3 py-2 text-sm bg-white h-10 focus:outline-none focus:ring-2 focus:ring-[#0596DE]"
          >
            <option value="0">{t('hydration_activity_none')}</option>
            <option value="1">{t('hydration_activity_1')}</option>
            <option value="2">{t('hydration_activity_2')}</option>
            <option value="3">{t('hydration_activity_3')}</option>
          </select>
        </div>
      </div>

      {valid && (
        <div className="rounded-2xl p-6 text-center bg-[#F8FAFC] border border-[#E2E8F0]">
          <div className="text-sm text-[#64748B] mb-1">{t('hydration_result_label')}</div>
          <div className="text-4xl font-bold text-[#0596DE]">{liters} L</div>
          <div className="text-sm text-[#64748B] mt-1">{t('hydration_result_note')}</div>
        </div>
      )}

      <p className="mt-6 text-sm text-[#64748B]">
        {t('hydration_disclaimer')}
      </p>
    </ToolPageLayout>
  );
};

export default HydrationCalculator;
